<template>
  <div>
    <div class="login-container">
      <div class="login-wrapper">
        <div class="left"></div>
        <div class="right">
          <div class="login-title">政策性农业保险服务平台</div>
          <div class="login-sub-title">{{ systemTypeName }}</div>
          <a-form @submit.prevent="doLogin" :form="form" class="login-form">
            <a-alert
              type="error"
              :closable="true"
              v-show="error"
              :message="error"
              showIcon
              style="margin-bottom: 24px"
            ></a-alert>

            <a-form-item>
              <a-input
                placeholder="请输入用户名"
                size="large"
                v-decorator="[
                  'name',
                  {
                    rules: [
                      {
                        required: true,
                        message: '请输入用户名',
                        whitespace: true,
                      },
                    ],
                  },
                ]"
              >
                <!-- <a-icon slot="prefix" type="user"></a-icon> -->
                <img
                  slot="prefix"
                  class="custom-input-prefix"
                  src="../../assets/images/user.png"
                />
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-input-password
                placeholder="输入密码"
                size="large"
                type="password"
                v-decorator="[
                  'password',
                  {
                    rules: [
                      {
                        required: true,
                        message: '请输入密码',
                        whitespace: true,
                      },
                    ],
                  },
                ]"
              >
                <!-- <a-icon slot="prefix" type="lock"></a-icon> -->
                <img
                  slot="prefix"
                  class="custom-input-prefix"
                  src="../../assets/images/pwd.png"
                />
              </a-input-password>
            </a-form-item>

            <a-form-item>
              <a-button
                :loading="loading"
                block
                size="large"
                htmlType="submit"
                type="primary"
                >登录</a-button
              >
            </a-form-item>
          </a-form>
        </div>
      </div>
    </div>

    <!-- <div :class="['login',(platformName&&(platformName==='luobei'))?'login2':'']">
        <a-form @submit.prevent="doLogin"
                :form="form">
          <a-alert type="error"
                   :closable="true"
                   v-show="error"
                   :message="error"
                   showIcon
                   style="margin-bottom: 24px;"></a-alert>
  
          <a-form-item label="用户名">
            <a-input placeholder="请输入用户名"
                     size="large"
                     v-decorator="['name', { rules: [{ required: true, message: '请输入用户名', whitespace: true }] }]">
              <a-icon slot="prefix" type="user"></a-icon>
            </a-input>
          </a-form-item>
          <a-form-item label="密码">
            <a-input placeholder="输入密码"
                     size="large"
                     type="password"
                     v-decorator="['password', { rules: [{ required: true, message: '请输入密码', whitespace: true }] }]">
              <a-icon slot="prefix" type="lock"></a-icon>
            </a-input>
          </a-form-item>
  
          <a-form-item>
            <a-button :loading="loading"
                      class="u-btn-success"
                      size="large"
                      htmlType="submit"
                      type="primary">登录</a-button>
          </a-form-item>
        </a-form>
      </div> -->

    <!-- 跳转统计图时显示loading -->
    <div class="project-loading" v-if="platform === '4' || unified">
      <div class="loader">
        <div class="loader-inner line-scale-pulse-out">
          <div style="background: #f95476"></div>
          <div style="background: #ffb74e"></div>
          <div style="background: #4886ff"></div>
          <div style="background: #ffb74e"></div>
          <div style="background: #f95476"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

import platformName from "@/utils/platform";

import { Encrypt } from "../../utils/Secret.js";

export default {
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  data() {
    return {
      loading: false,
      error: "",
      platform: "", // 平台id
      platformName: platformName,
      platformType: "", // 默认是萝北确权系统 true 则是萝北县惠农补贴数据认证系统
      unified: false, // 是否是统一用户登录 true是

      systemTypeList: {
        1: "省级主管部门入口",
        3: "县级主管部门入口",
        5: "协办人员入口",
      },
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.account.user,
    }),

    systemName() {
      return this.$store.state.setting.systemName;
    },
    copyright() {
      return this.$store.state.setting.copyright;
    },
    systemTypeName() {
      const systemType = this.$route.query.systemType;

      const name = systemType
        ? this.systemTypeList[systemType] || this.systemTypeList[1]
        : "";

      return name;
    },
  },
  created() {},
  mounted() {
    // this.$db.clear()
    // this.$router.options.routes = []
    // 获取路由传参
    // if (this.platformName === 'luobei') {
    //   // 处理萝北登录
    //   let searchUrl = decodeURI(window.location.href).split('?')
    //   // if (searchUrl.split('?').length <= 1) return
    //   // let param = searchUrl.split('?')[1].split('=')[1]
    //   // if (param === 'luobei') this.platformType = param
    //   if (searchUrl[0].indexOf('luobei') !== -1) {
    //     this.platformType = 'luobei'
    //   }
    // }

    if (window.location.href && this.platformName !== "luobei") {
      let searchUrl = decodeURI(window.location.href);

      // let params = searchUrl.replace('?params=', '')
      // 无查询参数不继续执行
      if (searchUrl.split("?").length <= 1) return;
      // 统一用户登录逻辑开始
      let href = searchUrl.split("?")[1];
      if (href.includes("unified")) {
        this.unified = true; // 统一用户登录
        try {
          // let queryParams = href.split('=')[1]
          let _queryParams = "";
          let _code = "";
          // let unified = null // 统一参数
          let _username = null; // 页面1保险端 2补贴端 3绥化种植业统计端 4绥化养殖业统计端
          let _platform = null; // 平台
          let _year = null; // 年度
          if (href.includes("&")) {
            // 多参数 page code
            _queryParams = href.split("&");

            // 获取page参数 根据参数跳转不同链接
            _queryParams.forEach((i) => {
              let _item = i.split("=");
              // if (item[0] === 'unified') {
              //   unified = item[1]
              // }
              if (_item[0] === "username") {
                _username = _item[1];
              }
              if (_item[0] === "acode") {
                _code = _item[1];
              }
              if (_item[0] === "platform") {
                _platform = _item[1];
              }
              if (_item[0] === "year") {
                _year = _item[1];
              }
            });
            this.doUnifiedLogin(_username, _code, _platform, _year);
          }
        } catch (e) {}
        // 统一用户结束
      } else {
        this.unified = false; // 非统一用户登录
        // 非统一用户
        let params = searchUrl.split("?")[1].replace("params=", "");

        // let params = window.location.search.replace("?params=", "");
        let passParams = JSON.parse(decodeURIComponent(params));
        if (passParams.platform && passParams.platform.toString()) {
          this.form.setFieldsValue({
            name: passParams.username,
            password: passParams.pwd,
          });

          // this.form.setFieldValue('password', passParams.pwd)
          this.platform = passParams.platform.toString();
          if (
            (passParams.username === "绥化市123" ||
              passParams.username === "sjdp") &&
            passParams.pwd === "1234qwer"
          ) {
            // 绥化大屏自动跳转
            this.doLogin({ year: passParams.year || "" });
          }
        }
      }
    }
  },

  methods: {
    /* 统一用户登录 */

    doUnifiedLogin(name, code, platform, year) {
      this.$post("/system/cas/login", {
        // username: encodeURI(name),
        username: name,
        aCode: code,
      })
        .then(async (r) => {
          // alert(JSON.stringify({name, nameEncodeUrl: encodeURI(name), code, platform}))
          // alert(JSON.stringify(r))
          if (r.data.code === "999") {
            this.$message.warning(r.data.message);
            return;
          }

          let data = r.data.data;
          // 统一返回的地址数据类型
          data.userArea.province = data.userArea.province
            ? parseInt(data.userArea.province)
            : "";
          data.userArea.city = data.userArea.city
            ? parseInt(data.userArea.city)
            : "";
          data.userArea.county = data.userArea.county
            ? parseInt(data.userArea.county)
            : "";
          data.userArea.country = data.userArea.country
            ? parseInt(data.userArea.country)
            : "";
          data.userArea.village = data.userArea.village
            ? parseInt(data.userArea.village)
            : "";
          localStorage["btname"] =
            data.userArea.province_name +
            "/" +
            data.userArea.city_name +
            "/" +
            data.userArea.county_name;
          localStorage["province_name"] = data.userArea.province_name;
          localStorage["city_name"] = data.userArea.city_name;
          localStorage["county_name"] = data.userArea.county_name;
          localStorage["userArea"] = data.userArea.county;
          localStorage["country_name"] = data.userArea.country_name;
          localStorage["country_code"] = data.userArea.country;

          await this.saveLoginData(data);
          setTimeout(() => {
            this.loading = false;
          }, 500);
          if (platform && platform === "4") {
            // 跳转承保一张图大屏
            if (year) {
              // 传年度，默认大屏年度
              this.$router.push({
                path: "/statistics",
                query: { year },
              });
            } else {
              // 未传年度
              this.$router.push("/statistics");
            }
          } else {
            this.$router.push("/");
          }
        })
        .catch((e) => {
          // console.error(e);
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    doLogin(params) {
      // // 测试跳转
      // let params = {platform: 1}
      // let urls = 'http://192.168.50.112:8086/#/login_suihua' + '?params=' + JSON.stringify(params)
      // 		urls = encodeURI(urls)
      // let newWindow = window.open('_blank')
      // newWindow.location = urls
      // return

      // 用户名密码登录
      this.form.validateFields(["name", "password"], (errors, values) => {
        if (!errors) {
          this.loading = true;
          let name = this.form.getFieldValue("name");
          let password = this.form.getFieldValue("password");
          this.$post("/system/login", {
            username: name,
            // password: password,
            password: Encrypt(password), // 密码加密
          })
            .then(async (r) => {
              let data = r.data.data;
              // 统一返回的地址数据类型
              data.userArea.province = data.userArea.province
                ? parseInt(data.userArea.province)
                : "";
              data.userArea.city = data.userArea.city
                ? parseInt(data.userArea.city)
                : "";
              data.userArea.county = data.userArea.county
                ? parseInt(data.userArea.county)
                : "";
              data.userArea.country = data.userArea.country
                ? parseInt(data.userArea.country)
                : "";
              data.userArea.village = data.userArea.village
                ? parseInt(data.userArea.village)
                : "";
              localStorage["btname"] =
                data.userArea.province_name +
                "/" +
                data.userArea.city_name +
                "/" +
                data.userArea.county_name;
              localStorage["province_name"] = data.userArea.province_name;
              localStorage["city_name"] = data.userArea.city_name;
              localStorage["county_name"] = data.userArea.county_name;
              localStorage["userArea"] = data.userArea.county;
              localStorage["country_name"] = data.userArea.country_name;
              localStorage["country_code"] = data.userArea.country;

              await this.saveLoginData(data);
              setTimeout(() => {
                this.loading = false;
              }, 500);
              // this.$router.push('/ledger');
              // this.$router.push('/')

              if (this.platform === "1") {
                // 农业保险管理系统 跳转到绥化大屏
                // this.$router.push('/insurance/insuranceClaims/TjInsuranceClaims')
                this.$router.push("/statistics");
              } else if (this.platform === "2") {
                // 惠农补贴公示系统1
                this.$router.push("/workAllowance/county");
              } else if (this.platform === "3") {
                // 生产者补贴管理系统1
                // this.$router.push('/')
                this.$router.push("/themePage/subsidyTheme");
              } else if (this.platform === "4") {
                // 跳转承保一张图大屏
                if (params && params.year) {
                  // 传年度，默认大屏年度
                  this.$router.push({
                    path: "/statistics",
                    query: { year: params.year },
                  });
                } else {
                  // 未传年度
                  this.$router.push("/statistics");
                }
              } else if (this.platformName === "luobei") {
                // 萝北县登录后进台账
                this.$router.push("/themePage/plant");
              } else if (this.platform === "5") {
                // 政府登录 跳转到农业保险管理(政府端)首页测试1 账号：beilinqu 密码：1234qwer
                this.$router.push("/themePage/agriculture");
              } else {
                this.$router.push("/");
              }
            })
            .catch((e) => {
              // console.error(e);
              setTimeout(() => {
                this.loading = false;
              }, 500);
            });
        }
      });
    },

    ...mapMutations({
      setToken: "account/setToken",
      setExpireTime: "account/setExpireTime",
      setPermissions: "account/setPermissions",
      setRoles: "account/setRoles",
      setUser: "account/setUser",
      setUserArea: "account/setUserArea",
      setTheme: "setting/setTheme",
      setLayout: "setting/setLayout",
      setMultipage: "setting/setMultipage",
      fixSiderbar: "setting/fixSiderbar",
      fixHeader: "setting/fixHeader",
      setColor: "setting/setColor",
      setPlatform: "setting/setPlatform",
      setUnified: "setting/setUnified",
    }),
    saveLoginData(data) {
      this.setToken(data.token);
      this.setExpireTime(data.exipreTime);
      this.setUser(data.user);
      this.setUserArea(data.userArea);
      this.setPermissions(data.permissions);
      this.setRoles(data.roles);
      // this.setTheme(data.config.theme);
      this.setLayout(data.config.layout);
      this.setMultipage(data.config.multiPage === "1");
      this.fixSiderbar(data.config.fixSiderbar === "1");
      this.fixHeader(data.config.fixHeader === "1");
      this.setColor(data.config.color);

      this.setPlatform(this.platformType);
      this.setUnified(this.unified); // 保存统一用户
    },
  },
};
</script>

<style lang="less" scoped>
.login-container {
  width: 100vw;
  height: 100vh;
  background: url("~@/assets/images/login-img/login-bj.png") no-repeat center
    center;
  background-size: cover;
  position: relative;
  .login-wrapper {
    width: 1166px;
    height: 620px;

    border-radius: 20px;
    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    .left {
      width: 680px;
      height: 100%;
      background: #fff url("~@/assets/images/login-img/login-left.png")
        no-repeat center center;
      background-size: cover;
    }
    .right {
      flex: 1;
      height: 100%;
      background: rgba(255, 255, 255, 0.8);

      padding: 110px 42px;
      .login-title {
        font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
        font-weight: bold;
        font-size: 36px;
        color: #454645;
        line-height: 1;
        text-align: center;
        margin-bottom: 22px;
      }
      .login-sub-title {
        height: 30px;
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 24px;
        color: #21b487;
        line-height: 1;
        text-align: center;
        margin-bottom: 48px;
      }

      .login-form {
        /deep/ .ant-form-item-control {
          line-height: 60px;
        }
        /deep/ .ant-input-lg {
          height: 60px;
          background: linear-gradient(#ebf0fb 0%, #ffffff 100%);
          box-shadow: inset 0px 3px 6px 1px rgba(255, 255, 255, 0.16);
          border: 2px solid #ffffff;
          color: #333;
          font-size: 16px;
        }
        /deep/ .ant-input-affix-wrapper .ant-input-prefix::after {
          content: "";
          width: 1px;
          height: 36px;
          background-color: #c6cbd1;
          position: absolute;
          right: -15px;
        }
        .custom-input-prefix {
          width: 20px;
          height: 20px;
          margin-left: 5px;
        }
        /deep/ .ant-btn-lg {
          height: 60px;
          font-size: 18px;
          //   margin-top: 20px;
        }
        /deep/ .ant-form-item {
          margin-bottom: 1.9rem !important;
        }
        /deep/ .ant-input-affix-wrapper .ant-input:not(:last-child),
        /deep/ .ant-input-affix-wrapper .ant-input:not(:first-child) {
          padding-left: 60px;
        }
      }
    }
  }
}

// .login {
//   .icon {
//     font-size: 24px;
//     color: rgba(0, 0, 0, 0.2);
//     margin-left: 16px;
//     vertical-align: middle;
//     cursor: pointer;
//     transition: color 0.3s;

//     &:hover {
//       color: #1890ff;
//     }
//   }
//   .u-btn-success {
//     width: 100%;
//     margin-top: 4px;
//     background: #183fa9;
//     border-color: #183fa9;
//     height: 44px;
//     line-height: 44px;
//     font-size: 16px !important;
//     &:hover {
//       background: #183fa9;
//     }
//   }
// }
// .login2 {
//   .u-btn-success {
//     width: 100%;
//     margin-top: 4px;
//     background: #23aa85;
//     border-color: #23aa85;
//     height: 44px;
//     line-height: 44px;
//     font-size: 16px !important;
//     &:hover {
//       background: #23aa85;
//     }
//   }
//   /deep/ .ant-form-item-label label {
//     font-size: 16px !important;
//   }
// }

/deep/.project-loading {
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/views/loginSuihua/Login.vue